/**
 * Whether the current ruleset declares a given setting (PSTATS-1380).
 *
 * A stored configuration keeps settings left behind by a previous ruleset, and
 * that is deliberate: a boxscore prices already-recorded plays from those
 * values, so a game recorded under Indoor still needs `scoring.dropKickFieldGoal`
 * to value its drop kicks at 4 even after the event is switched to Standard.
 * Removing them from the configuration would silently rescore the game.
 *
 * They must not be OFFERED as settings of the ruleset in force, though - a
 * Standard Football form has no business showing Deuce Score. So the values
 * stay and the form asks this before rendering a field.
 *
 * Fails open in both directions. Without defaults, or for a section they do not
 * describe, everything renders: a caller that does not supply them keeps
 * today's behaviour, and a shape mismatch shows a field too many rather than
 * blanking a whole section.
 */
export const declaresSetting = (rulesetDefaults, section, key) => {
	const declared = rulesetDefaults?.[section];
	if (!declared) {
		return true;
	}
	// `in`, not truthiness - 0 and false are real settings.
	return key in declared;
};
